<template>
  <div>
    <contract-basic-info-termination-box
      v-if="schedule.is_terminated === 1"
      :client-name="clientName"
      :isAdmin="isAdmin"
      :schedule="schedule"/>
      
    <contract-basic-info-explained-box
      v-if="schedule.case_is_explained && !schedule.is_terminated"
      :schedule="schedule"/>

    <contract-basic-info-header
      :all-guarantees-have-agreement="allGuaranteesHaveAgreement"
      :is-admin="isAdmin"
      :is-draft="isDraft"
      :is-for-internal-client="isForInternalClient"
      :schedule="schedule"
      :schedule-finished="scheduleFinished" />

    <contract-loan-summary
      :is-draft="isDraft"
      :schedule="schedule" />

    <contract-loan-summary-before-discount
      v-if="schedule.discount_active"
      :is-draft="isDraft"
      :schedule="schedule" />

    <contract-basic-info-data
      :all-companies="allCompanies"
      :client-type="clientType"
      :export-in-progress="exportInProgress"
      :is-draft="isDraft"
      :interests-loading="interestsLoading"
      :last-installment="lastInstallment"
      :schedule-prop="schedule" />

    <contract-loan-cost-breakdown-modal
      ref="contractLoanCostBreakdownModal"
      :schedule="schedule"
      :schedule-id="schedule.id" />
  </div>
</template>

<script>
import ContractBasicInfoData from '@/components/client/contract-partials/basic-info/ContractBasicInfoData';
import ContractBasicInfoHeader from '@/components/client/contract-partials/basic-info/ContractBasicInfoHeader';
import ContractBasicInfoExplainedBox from '@/components/client/contract-partials/basic-info/ContractBasicInfoExplainedBox';
import ContractBasicInfoTerminationBox from '@/components/client/contract-partials/basic-info/ContractBasicInfoTerminationBox';
import ContractLoanSummary from '@/components/client/contract-partials/ContractLoanSummary';
import ContractLoanSummaryBeforeDiscount from '@/components/client/contract-partials/ContractLoanSummaryBeforeDiscount';
import ContractLoanCostBreakdownModal from '@/components/client/contract-partials/ContractLoanCostBreakdownModal.vue';

export default {
  name: 'ContractBasicInfo',
  components: {
    ContractBasicInfoData,
    ContractBasicInfoHeader,
    ContractBasicInfoTerminationBox,
    ContractLoanSummary,
    ContractLoanSummaryBeforeDiscount,
    ContractLoanCostBreakdownModal,
    ContractBasicInfoExplainedBox
  },
  props: {
    allCompanies: {
      default: () => [],
      type: Array
    },
    allGuaranteesHaveAgreement: {
      default: false,
      type: Boolean
    },
    clientName: {
      default: '',
      type: String
    },
    clientType: {
      required: true,
      type: String
    },
    exportInProgress: {
      default: false,
      type: Boolean
    },
    interestsLoading: {
      default: false,
      type: Boolean
    },
    isAdmin: {
      default: 0,
      type: Number
    },
    isDraft: {
      required: true,
      type: Boolean
    },
    isForInternalClient: {
      default: false,
      type: Boolean
    },
    lastInstallment: {
      default: 0,
      type: Number
    },
    schedule: {
      required: true,
      type: Object
    },
    scheduleFinished: {
      default: false,
      type: Boolean
    }
  },
  mounted () {
    this.$bus.$on('view-details', this.viewDetails);
  },
  methods: {
    viewDetails (viewType, viewLoanSum, viewLoanSumTitle, shouldShowPaidSum) {
      this.$refs.contractLoanCostBreakdownModal.showModal(viewType, viewLoanSum, viewLoanSumTitle, shouldShowPaidSum);
    }
  },
  beforeDestroy () {
    this.$bus.$off('view-details', this.viewDetails);
  }
}
</script>
